import { UIManager } from './UIManager';
export const UI: UIManager = new UIManager();
